/**
 * Thin Device Orders controller. Forwards UI calls to the service unchanged.
 * Per the project's hexagonal rules: controllers are thin; all business logic
 * lives in the service.
 *
 * Type lives in `src/hexagon/adapters/types/deviceOrdersController.d.ts`.
 */

export const DeviceOrdersControllerFactory = ({
  deviceOrdersService,
}: {
  deviceOrdersService: IDeviceOrdersService;
}): IDeviceOrdersController => ({
  list: deviceOrdersService.list,
  create: deviceOrdersService.create,
  update: deviceOrdersService.update,
  remove: deviceOrdersService.remove,
});
